﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
import loginApp from './vue/login';
import userStateApp from './vue/userState';
import registrationApp from './vue/register';
import directPaymentApp from './vue/payDirectly';
import payAgreementApp from './vue/payAgreement';
import passwordApp from './vue/forgotPassword';
import outstandingApp from './vue/outstanding';
import loginStateApp from './vue/loginState';
import claimsApp from './vue/claims';
import claimDetailApp from './vue/claimDetail';
import paymentStatusApp from './vue/paymentStatus';
import objectionApp from './vue/objection';
import tabsApp from './vue/tabs';

import userStore from './vue/store/loginState.store';

document.addEventListener('DOMContentLoaded', () => {
    const loginComponent = document.getElementById('loginForm');
    if (loginComponent) {
        createApp(loginApp).mount(loginComponent);
    }

    const registrationComponent = document.getElementById('registerForm');
    if (registrationComponent) {
        createApp(registrationApp).mount(registrationComponent);
    }

    const directPaymentComponent = document.getElementById('directPayment');
    if (directPaymentComponent) {
        createApp(directPaymentApp).mount(directPaymentComponent);
    }

    const passwordComponent = document.getElementById('forgotPasswordForm');

    if (passwordComponent) {
        createApp(passwordApp).mount(passwordComponent);
    }

    const userState = document.getElementById('userState');
    if (userState) {
        createApp(userStateApp).use(userStore).mount(userState);
    }

    const payAgreement = document.getElementById('payAgreement');
    if (payAgreement) {
        createApp(payAgreementApp).mount(payAgreement);
    }

    const outstandingPayment = document.getElementById('outstanding');
    if (outstandingPayment) {
        createApp(outstandingApp).mount(outstandingPayment);
    }

    const claims = document.getElementById('myClaims');
    if (claims) {
        createApp(claimsApp).mount(claims);
    }

    const claimDetail = document.getElementById('claimDetail');
    if (claimDetail) {
        createApp(claimDetailApp).mount(claimDetail);
    }
    
    const loginStates = document.querySelectorAll('.loginStateDependent');
    loginStates.forEach((loginState) => {
        createApp(loginStateApp).use(userStore).mount(loginState);
    });

    const paymentStatus = document.getElementById('paymentStatus');
    if (paymentStatus) {
        createApp(paymentStatusApp).mount(paymentStatus);
    }
    
    const objection = document.getElementById('objectionRequest');
    if (objection) {
        createApp(objectionApp).mount(objection);
    }

    const tabComponents = document.querySelectorAll('.tabComponent');
    tabComponents.forEach((tabComponent) => {
        createApp(tabsApp).mount(tabComponent);
    });

});